module.exports = __webpack_public_path__ + "img/img-otp.c0a7f5ef.svg";